'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$97() {
  this.c3A = null;
  this.c3B = false;
}
export { $c_Lpresto_types$$anon$97 as $c_Lpresto_types$$anon$97 };
$p = $c_Lpresto_types$$anon$97.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$97;
/** @constructor */
function $h_Lpresto_types$$anon$97() {
}
export { $h_Lpresto_types$$anon$97 as $h_Lpresto_types$$anon$97 };
$h_Lpresto_types$$anon$97.prototype = $p;
$p.P = (function() {
  if ((!this.c3B)) {
    this.c3A = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.c3B = true;
  }
  return this.c3A;
});
var $d_Lpresto_types$$anon$97 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$97, "presto.types$$anon$97", ({
  Yl: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_types$$anon$97 as $d_Lpresto_types$$anon$97 };
//# sourceMappingURL=presto.types$$anon$97.js.map
